const BASE_URL = "https://shyaminstitute.com/api";
// const BASE_URL = "http://localhost:5000";

export default BASE_URL;
